import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { FilterValueLifecycleStatus } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";

export const createChip = (
    tag: string,
    getLifecycleStatus?: (value: Partial<string>) => FilterValueLifecycleStatus,
): ChipItem => {
    return {
        id: tag,
        text: tag,
        chipStatus: getLifecycleStatus?.(tag),
    };
};
